import { render, staticRenderFns } from "./StaffV2.vue?vue&type=template&id=71cb71f4&scoped=true"
import script from "./StaffV2.vue?vue&type=script&lang=js"
export * from "./StaffV2.vue?vue&type=script&lang=js"
import style0 from "./StaffV2.vue?vue&type=style&index=0&id=71cb71f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb71f4",
  null
  
)

export default component.exports